export default "__VITE_ASSET__DJYqBgV9__"